import * as ProjectHelper from '../../api/project/projectHelper';
import { IProject } from '../../shared/iProject';
import validationAlertOutput from '../../validation';
import CalculationProvider from './calculationProvider';
import { cleanObject, convertDecimals } from './util';

export const getAllCalculatedScenariosAsync = async (project: IProject, authorEmail: string) => {
    let resUpdateProject = await ProjectHelper.saveProjectAsync(project, authorEmail);
    if (resUpdateProject?.status == 200) {
        let res = await CalculationProvider.getAllCalculatedScenariosAsync(resUpdateProject?.data!);
        res.data = cleanObject(res.data);
        res.data = convertDecimals(res.data);
        validationAlertOutput(res.data);
        return res;
    }
};
